<template>
	<div id="app">
		<router-view />
		<bootom></bootom>
	</div>
</template>

<script>
	import bootom from './components/bootom.vue';
	export default {
		name: 'App',
		components: {
			bootom
		}
	}
</script>

<style>
	#app {}
</style>